const axios = require("axios").create({
  baseURL: process.env.REACT_APP_TUGE_BASE_URL
});

export default axios;